import { render, staticRenderFns } from "./SMItemBox.vue?vue&type=template&id=06d8c805&scoped=true&"
import script from "./SMItemBox.vue?vue&type=script&lang=js&"
export * from "./SMItemBox.vue?vue&type=script&lang=js&"
import style0 from "./SMItemBox.vue?vue&type=style&index=0&id=06d8c805&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d8c805",
  null
  
)

export default component.exports